import { render, staticRenderFns } from "./mcico.vue?vue&type=template&id=97246f94&scoped=true"
import script from "./mcico.vue?vue&type=script&lang=js"
export * from "./mcico.vue?vue&type=script&lang=js"
import style0 from "./mcico.vue?vue&type=style&index=0&id=97246f94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97246f94",
  null
  
)

export default component.exports